import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { PowerPlantRequestData, ProjectRequestData } from './power-plant-request-data';

export class PowerPlantFormData {

  formData = new FormData();

  constructor(
    public requestData: ProjectRequestData,
    public calculatorResultWrapper: CalculatorResultWrapper,
    public image?: Blob,
  ) {
    this.formData.append('projectData', JSON.stringify(new PowerPlantRequestData(this.calculatorResultWrapper, requestData)));
    this.formData.append('analysisRequest', JSON.stringify(this.calculatorResultWrapper.request));
    this.formData.append('analysisResponse', JSON.stringify(this.calculatorResultWrapper.result));
    this.formData.append('locationPicture', image || new Blob(), image ? 'locationPicture.png' : 'empty.png');
  }
}
